module.exports = __webpack_public_path__ + "banquet/components/AppStoreBadges/images/apple_app_store.8b10c25993ca5ce69b8435a15a0f849a.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AppStoreBadges/images/apple_app_store.svg
// module id = 1649
// module chunks = 1